import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: " p-d-flex p-flex-column kn-flex kn-overflow"
}
const _hoisted_2 = {
  key: 1,
  class: "kn-flex kn-overflow"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ScorecardsTableHint = _resolveComponent("ScorecardsTableHint")
  const _component_ScorecardsPerspectiveItem = _resolveComponent("ScorecardsPerspectiveItem")

  return (_ctx.scorecard)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.scorecards.perspectives')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              label: _ctx.$t('managers.scorecards.addPerspective'),
              class: "p-button-text p-button-rounded p-button-plain kn-white-color",
              onClick: _ctx.addPerspective,
              "data-test": "add-perspective-button"
            }, null, 8, ["label", "onClick"])
          ]),
          _: 1
        }),
        (_ctx.scorecard.perspectives.length === 0)
          ? (_openBlock(), _createBlock(_component_ScorecardsTableHint, {
              key: 0,
              class: "p-my-2",
              hint: 'managers.scorecards.addPerspectiveHint',
              "data-test": "no-perspective-hint"
            }, null, 8, ["hint"]))
          : (_openBlock(), _createBlock("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scorecard.perspectives, (perspective, index) => {
                return (_openBlock(), _createBlock(_component_ScorecardsPerspectiveItem, {
                  key: index,
                  propPerspective: perspective,
                  criterias: _ctx.criterias,
                  kpis: _ctx.kpis,
                  onDeletePerspective: _ctx.deletePerspective,
                  onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('touched')))
                }, null, 8, ["propPerspective", "criterias", "kpis", "onDeletePerspective"]))
              }), 128))
            ]))
      ]))
    : _createCommentVNode("", true)
}